import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import type { IYoutube } from "../../../../pages/Party/YoutubeMatchingInfo";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import AlertModal from "../../../Modal/AlertModal";
import { saveYoutubeUrlAllocation } from "./youtubeExtrainfoApi";

export default function YoutubeRoundActivationModal({
  round,
  closeEvent,
  onSaved,
}: {
  round: IYoutube;
  closeEvent: () => void;
  onSaved: () => void;
}) {
  const [step, setStep] = useState<"initial" | "final">("initial");
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const [error, setError] = useState("");

  const confirm = async () => {
    if (savingRef.current) return;
    if (step === "initial") {
      setStep("final");
      return;
    }
    const roundNumber = Number(round.yt_round);
    if (!round.partyid || !round.uid || !Number.isInteger(roundNumber) || roundNumber < 1 || roundNumber > 12) {
      setError("현재 회차 정보를 확인할 수 없습니다. 목록을 새로고침해 주세요.");
      return;
    }
    savingRef.current = true;
    setSaving(true);
    setError("");
    try {
      const result = await saveYoutubeUrlAllocation({
        provider: round.provider ?? undefined,
        pid: String(round.partyid),
        uid: String(round.uid),
        email: round.yt_r_email ?? "",
        round: roundNumber,
        r_status: 3,
        r_link: round.yt_r_link ?? "",
      });
      if (result.r_status !== 3 || result.round !== roundNumber) {
        throw new Error("회차상태가 변경되지 않았습니다. 다시 확인해 주세요.");
      }
    } catch {
      setError("활성화 완료로 변경하지 못했습니다. 다시 시도해 주세요.");
      return;
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
    toast.success("해당 회차를 활성화 완료로 변경했습니다.");
    onSaved();
  };

  return (
    <AlertModal
      key={step}
      title={step === "initial"
        ? '해당 회차를 "활성화 완료"로 변경할까요?'
        : "정말 해당회차를 활성화 완료로 할까요?"}
      desc={`${round.yt_round ?? "-"}회차 · ${round.yt_r_email ?? ""}`}
      pointDesc={error ? <span role="alert">{error}</span> : undefined}
      customCancelBtn={
        <ConfirmBtn btnText="취소" btnColor="white" isDisabled={saving} btnClickEvent={closeEvent} />
      }
      customConfirmBtn={
        <ConfirmBtn
          btnText={saving ? "저장 중…" : "확인"}
          btnColor="mint"
          isDisabled={saving}
          btnClickEvent={() => void confirm()}
        />
      }
    />
  );
}
